import React, { Component } from "react";
import { connect } from "react-redux";
import { Card } from "react-bootstrap";
import "./myplan.css";

class Item extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.getVideoId = this.getVideoId.bind(this);
  }
  getVideoId(video) {
    var index = video.indexOf("v=");
    if (index > 0) {
      let id = video.slice(index + 2, index + 2 + 11);
      return id;
    } else {
      index = video.indexOf(".be/");
      let id = video.slice(index + 4, index + 4 + 11);
      return id;
    }
  }
  render() {
    return (
      <Card style={{ margin: ".5rem 0" }}>
        <Card.Body className={"container"} style={{ padding: "0.5rem" }}>
          {/* COPY AND DELETE */}
          <div className={"rutine-title"} >
            <h5
                className="plan-title"
                style={{
                  fontSize: "14px",
                }}
            >
              {this.props.ejercice.Exercise_Name_Complete}
            </h5>
            <div className="icons">
              <i
                  onClick={() =>
                      this.props.copyEjercice(
                          this.props.colum,
                          this.props.ejercice
                      )
                  }
                  className="far fa-copy"
                  style={{ fontSize: "16px" }}
              ></i>
              <i
                  onClick={() =>
                      this.props.deleteEjercice(
                          this.props.colum,
                          this.props.index
                      )
                  }
                  className="far fa-trash-alt"
                  style={{ fontSize: "16px", paddingRight: "0" }}
              ></i>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div style={{ display: "flex" }}>
                <Card.Img
                  variant="top"
                  src={
                    this.props.ejercice.Recommend_Image === 1
                      ? this.props.ejercice.Small_Img_1
                      : this.props.ejercice.Small_Img_2
                  }
                  alt="ejercicio"
                  style={{
                    zIndex: "2",
                    width: "100px",
                    paddingRight: "10px",
                      height: "fit-content"
                  }}
                />
                <div>
                  <h5
                      className="plan-title plan-title-large-screen"
                      style={{
                        fontSize: "14px",
                      }}
                  >
                    {this.props.ejercice.Exercise_Name_Complete}
                  </h5>
                  <p
                    style={{
                      fontSize: "10px",
                      marginBottom: "2px",
                      textTransform: "capitalize",
                    }}
                  >
                    <b>Músculo:</b> {this.props.ejercice.Target_Muscle_Group}
                  </p>
                  <p
                    style={{
                      fontSize: "10px",
                      marginBottom: "0px",
                      textTransform: "capitalize",
                    }}
                  >
                    <b>Implementos:</b>{" "}
                    {this.props.ejercice.Apparatus_Groups_Name}
                  </p>
                </div>
              </div>
            </div>
            {/* SETS Y REPS */}
            <div
              className="col-12 col-md-4 col-lg-3"
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "1rem 0px",
                marginBottom: "0px"
              }}
            >
              <div className="selector">
                <div style={{ display: "flex", alignItems: "center" }}>
                  <i
                    onClick={() =>
                      this.props.changeSets(
                        this.props.colum,
                        this.props.index,
                        this.props.ejercice.sets - 1
                      )
                    }
                    className="fas fa-minus"
                    style={{
                      color: this.props.ejercice.sets === 1 ? "#cecece" : null,
                    }}
                  ></i>
                  <label className="number">Sets: {this.props.ejercice.sets}</label>
                  <i
                    onClick={() =>
                      this.props.changeSets(
                        this.props.colum,
                        this.props.index,
                        this.props.ejercice.sets + 1
                      )
                    }
                    style={{
                      color: this.props.ejercice.sets === 50 ? "#cecece" : null,
                    }}
                    className="fas fa-plus"
                  ></i>
                </div>
              </div>
              <div className="selector">
                <div style={{ display: "flex", alignItems: 'center' }}>
                  <i
                    onClick={() =>
                      this.props.changeReps(
                        this.props.colum,
                        this.props.index,
                        this.props.ejercice.reps - 1
                      )
                    }
                    className="fas fa-minus"
                    style={{
                      color: this.props.ejercice.reps === 1 ? "#cecece" : null,
                    }}
                  ></i>
                  <label className="number">Reps: {this.props.ejercice.reps}</label>
                  <i
                    onClick={() =>
                      this.props.changeReps(
                        this.props.colum,
                        this.props.index,
                        this.props.ejercice.reps + 1
                      )
                    }
                    style={{
                      color: this.props.ejercice.reps === 50 ? "#cecece" : null,
                    }}
                    className="fas fa-plus"
                  ></i>
                </div>
              </div>
            </div>
            <div className={"col-12 col-md-2 col-lg-3 rutine-title-large-screen"} style={{
              margin: "1rem 0px",
              marginBottom: "0px"
            }} >
              <div className="icons">
                <i
                    onClick={() =>
                        this.props.copyEjercice(
                            this.props.colum,
                            this.props.ejercice
                        )
                    }
                    className="far fa-copy"
                    style={{ fontSize: "16px" }}
                ></i>
                <i
                    onClick={() =>
                        this.props.deleteEjercice(
                            this.props.colum,
                            this.props.index
                        )
                    }
                    className="far fa-trash-alt"
                    style={{ fontSize: "16px", paddingRight: "0" }}
                ></i>
              </div>
            </div>

          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              margin: ".5rem 0px",
              marginTop: "1rem",
              fontSize: "10px",
            }}
          >
            <label
              style={{
                color: this.props.dayIndex === 0 ? "#d2d2d2" : null,
                cursor: "pointer",
                marginBottom: "0",
                display: "flex",
                alignItems: "flex-end",
              }}
              onClick={() => this.props.MoveToPrev(this.props.index)}
            >
              <i
                className="fas fa-chevron-left"
                style={{ fontSize: "14px", marginRight: "5px" }}
              ></i>{" "}
              Mover al día anterior
            </label>
            <label
              style={{
                color:
                  this.props.dayIndex >= this.props.personalPlan.length - 1
                    ? "#d2d2d2"
                    : null,
                cursor: "pointer",
                marginBottom: "0",
                display: "flex",
                alignItems: "flex-end",
              }}
              onClick={() => this.props.MoveToNext(this.props.index)}
            >
              Mover al día siguiente{" "}
              <i
                className="fas fa-chevron-right"
                style={{ fontSize: "14px", marginLeft: "5px" }}
              ></i>
            </label>
          </div>
        </Card.Body>
      </Card>
    );
  }
}
const mapStateToProps = (state) => ({
  dayIndex: state.dayIndex,
  personalPlan: state.personalPlan,
});
const mapDispatchToProps = (dispatch) => ({

  deleteEjercice(colum, index) {
    dispatch({
      type: "DELETE_EJERCICE",
      colum: colum,
      index: index,
    });
  },
  copyEjercice(colum, ejercice) {
    dispatch({
      type: "COPY_EJERCICE",
      colum: colum,
      ejercice: ejercice,
    });
  },
  changeSets(colum, index, value) {
    if (value > 0 && value < 51) {
      dispatch({
        type: "SETS",
        colum: colum,
        index: index,
        value: value,
      });
    }
  },
  changeReps(colum, index, value) {
    if (value > 0 && value < 51) {
      dispatch({
        type: "REPS",
        colum: colum,
        index: index,
        value: value,
      });
    }
  },
  MoveToNext(id) {
    dispatch({
      type: "CHANGE_TO_NEXT_DAY",
      id: id,
    });
  },
  MoveToPrev(id) {
    dispatch({
      type: "CHANGE_TO_PREV_DAY",
      id: id,
    });
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(Item);
